import { useState } from 'react'

const useCustomerRequestInstructionsModalState = customerInstructions => {
  const [editModalState, setEditModalState] = useState({
    open: false,
    instructionsToEdit: null,
  })
  const [deleteModalState, setDeleteModalState] = useState({
    open: false,
    instructionToDelete: null,
  })
  const [createModalState, setCreateModalState] = useState({
    open: false,
    instructionToCreate: null,
  })

  // action modal handlers for opening / closing create, edit and delete modals.
  const handleModalOpen = type => row => {
    switch (type) {
      case 'create':
        setCreateModalState(prev => ({
          ...prev,
          open: true,
        }))
        break
      case 'edit':
        const instruction = customerInstructions.find(instruction => instruction.id === row.id)

        setEditModalState({
          open: true,
          instructionToEdit: instruction,
        })
        break
      case 'delete':
        setDeleteModalState({
          open: true,
          instructionToDelete: row,
        })
        break
      default:
        break
    }
  }

  const handleModalClose = () => {
    setCreateModalState({
      open: false,
      instructionToCreate: null,
    })
    setEditModalState({
      open: false,
      instructionToEdit: null,
    })
    setDeleteModalState({
      open: false,
      instructionToDelete: null,
    })
  }

  return {
    // action modal handlers
    handleModalOpen,
    handleModalClose, // resets the state for all modals
    // action modal states
    createModalState,
    editModalState,
    deleteModalState,
  }
}

export default useCustomerRequestInstructionsModalState
